var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ADADD0",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.598,
    d: "M6.371 9.907v6.86M11.038 6.624v10.143M15.629 13.532v3.235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.314 1.705C3.048 1.705 1 4.017 1 7.29v8.83c0 3.273 2.038 5.585 5.314 5.585h9.372c3.276 0 5.314-2.312 5.314-5.585V7.29c0-3.273-2.038-5.585-5.314-5.585H6.314z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon-analytics.d1f57732394d8f171099f7a6796b17ea.svg";
export { ForwardRef as ReactComponent };